import { render, staticRenderFns } from "./DeviceViewPage.vue?vue&type=template&id=6165d7d0&"
import script from "./DeviceViewPage.vue?vue&type=script&lang=js&"
export * from "./DeviceViewPage.vue?vue&type=script&lang=js&"
import style0 from "./DeviceViewPage.vue?vue&type=style&index=0&id=6165d7d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports